module.exports = __webpack_public_path__ + "media/assets/omniauth-microsoft-logo-42b61fa109e1e5d566ff8226348f1657.svg";